module.exports = __webpack_public_path__ + "static/media/multi-languages.3bd425d6.svg";